import {Component} from '@angular/core';
import {IonRouterOutlet} from '@ionic/angular/standalone';

/**
 * Layout component for authenticated pages.
 * This component includes the menu and router outlet for authenticated routes.
 */
@Component({
	           selector: 'app-authenticated-layout',
	           template: `
		           <ion-router-outlet></ion-router-outlet>
	           `,
	           imports: [
		           IonRouterOutlet
	           ],
	           standalone: true
           })
export class AuthenticatedLayoutComponent {
}
